import React from "react";
import { Progress, Card, Tooltip } from "antd";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from "recharts";

const AttendanceOvertimeDashboard: React.FC = () => {
    const overtimeData = [
        { name: "Jan Week 1", hours: 25 },
        { name: "Jan Week 2", hours: 15 },
        { name: "Jan Week 3", hours: 22 },
        { name: "Jan Week 4", hours: 20 }
    ];

    const weeks = [
        { label: "Week 1", onTime: 92 },
        { label: "Week 2", onTime: 90 },
        { label: "Week 3", onTime: 91 },
        { label: "Week 4", onTime: 93 },
        { label: "Week 5", onTime: 89 },
    ];

    return (
        <div className="w-full mt-4 ">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                {/* Attendance */}
                <Card title="Team Attendance Info" className="rounded-xl shadow-sm md:col-span-4">
                    <div className="space-y-4">
                        {weeks.map((w) => (
                            <div key={w.label}>
                                <div className="text-sm text-gray-500 mb-1">{w.label}</div>
                                <div className="flex items-center gap-2">
                                    <Progress
                                        percent={w.onTime}
                                        showInfo={false}
                                        strokeColor="#52c41a"
                                        trailColor="#f97316"
                                        className="flex-1"
                                    />
                                    <div className="w-2 h-2 rounded-full bg-red-500" />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="flex gap-6 mt-6 text-sm">
                        <span className="flex items-center gap-2">
                            <span className="w-3 h-3 bg-green-500" /> On Time
                        </span>
                        <span className="flex items-center gap-2">
                            <span className="w-3 h-3 bg-orange-500" /> Late
                        </span>
                        <span className="flex items-center gap-2">
                            <span className="w-3 h-3 bg-red-500" /> Leave
                        </span>
                    </div>
                </Card>

                {/* Overtime */}
                <Card title="Overtime Working Trends" className="rounded-xl shadow-sm md:col-span-8">
                    <ResponsiveContainer width="100%" height={250}>
                        <AreaChart data={overtimeData}>
                            <Area type="monotone" dataKey="hours" stroke="#f87171" fill="#fecaca" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                        </AreaChart>
                    </ResponsiveContainer>
                </Card>
            </div>
        </div>
    );
};

export default AttendanceOvertimeDashboard;
